export default __webpack_public_path__ + "static/media/R10.2669d07c.JPG";